// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_f6r","cls2":"Comments-cls2_BS8 Comments-cls1_f6r"};